import { Durations } from '@/constants/durations'
import { paths } from '@/constants/paths'
import { getBasicPageMetaData, Seo } from '@/layout/Seo'
import { CollectiblesLayout } from '@/layouts/CollectiblesLayout'
import { NextPageWithLayout } from '@/layouts/types'
import { getStaticPropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'
import { noPreRenderedStaticPaths } from '@/utils/nextUtils/staticPages'
import { useTranslate } from '@/utils/translate/translate-client'
import { loadTranslations } from '@/utils/translate/translate-server'
import { CollectiblesViewWingfeather } from '@/views/CollectiblesViews/CollectiblesViewWingfeather'

interface CollectiblesWingfeatherLandingProps {
  locale: string
}

export const CollectiblesWingfeatherLanding: NextPageWithLayout<CollectiblesWingfeatherLandingProps> = ({ locale }) => {
  const { t } = useTranslate('collectibles')

  const title = t('angelCollectibleScenes', 'Angel Collectible Scenes')
  const description = t(
    'ownADigitalFrameAngel',
    'Own a digital frame of your favorite shows and movies from Angel and help support future shows.',
  )

  return (
    <>
      <Seo
        {...getBasicPageMetaData({
          locale,
          path: paths.collectibles.index,
          title,
          description,
          cloudinaryImagePath: 'v1756153598/angel-studios/seo/angel-opengraph-5',
          cloudinaryTransformation: '',
        })}
        noindex
      />
      <div className="pt-16">
        <CollectiblesViewWingfeather />
      </div>
    </>
  )
}

export const getStaticProps = getStaticPropsErrorHandler<CollectiblesWingfeatherLandingProps>(
  { filePath: 'pages/[locale]/collectibles/[projectId]/index.tsx' },
  async ({ locale }) => {
    return {
      props: {
        locale,
        ...(await loadTranslations(locale, ['common', 'collectibles', 'pif'])),
      },
      revalidate: Durations.ONE_DAY_IN_SECONDS,
    }
  },
)

export const getStaticPaths = noPreRenderedStaticPaths

CollectiblesWingfeatherLanding.getLayout = (page) => {
  return (
    <CollectiblesLayout title="Collectibles" isDarkMode={false}>
      {page}
    </CollectiblesLayout>
  )
}

export default CollectiblesWingfeatherLanding
